import React, { FC } from 'react';
import styles from './VideoControls.scss';
import { IOuter } from '../../../Gallery/GalleryFile/GalleryFileControls/GalleryFileControls.types';

export const VideoControls: FC<IOuter> = ({ onPlayClick }) => (
  <div className={styles.videoPlayButton} onClick={onPlayClick} data-hook="video-play-button" />
);
